import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// This is the library used for shadcn/ui
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
